export const BASE_CLASSNAME = 'PONCHO-typography';
//# sourceMappingURL=enum.js.map